import React from "react";
import Chart from "react-apexcharts";

export default function FemaleEductionChart({data}) {
  



  const totalCount = data?.reduce((sum, item) => sum + item.count, 0);
  const names = data?.map(n => n?.name);
  const quantities = data?.map(
    (item) => parseFloat(((item.count / totalCount) * 100).toFixed(1)) // Round to 2 decimal places
  );

  const options = {
    labels: names,
    legend: {
      show: false,
    },
    colors: ["#9DBCEC", "#6D9AE3", "#3C79D9", "#094DC3", "#CEDDF6"],
    chart: {
      type: "pie",
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        // const name = opts.w.config.labels[opts.seriesIndex];
        return `${val.toLocaleString()}%`;
      },
      style: {
        fontSize: '14px',
        colors: ['#000'],
        fontWeight: 'normal'
      },
      dropShadow: {
        enabled: false
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return `${val}%`;
        },
      },
    },
    stroke: {
      show: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
            offset: -20,
          },
      },
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: "300",
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          chart: {
            width: "230",
          },
          dataLabels: {
            style: {
              fontSize: '10px',
            },
          },
        },
      },
    ]
  };

  const series = quantities;

  return <Chart options={options} series={series} type="pie" width="400" className="chart-center" />;
}
